import type { Cart } from 'core/domains';
import { useQueryState } from 'core/use-cases/utilities';

import {
  useCartPropertyByKeySelector,
  useCartSelectedShippingModel,
  useCartSelector,
  useComboEditConfirmationSelector,
  useCouponSelector,
  useDeleteConfirmationSelector,
  useMinOrderConfirmationSelector,
} from '../selectors';

/**
 * Return cart content and your async request handling
 *
 */
export function useCart() {
  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(useCartSelector);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
  };
}

export function useCoupon() {
  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(useCouponSelector);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
  };
}

/**
 * Receive a key and return info of cart context
 *
 */
export function useCartPropertyByKey(key: keyof Cart) {
  const data = useCartPropertyByKeySelector(key);

  return data as Cart[typeof key];
}

/**
 * Return shipping model of cart context
 *
 */
export function useCartShippingModel() {
  const data: Cart['current'] = useCartSelectedShippingModel();

  return data;
}

/**
 *  Return of item data and control of is cart open
 *
 */
export function useDeleteConfirmation() {
  const { data, isOpen } = useDeleteConfirmationSelector();

  return {
    data,
    isOpen,
  };
}

/**
 *  Return of item data and control of is cart open
 *
 */
export function useMinOrderConfirmation() {
  const { isOpen } = useMinOrderConfirmationSelector();

  return {
    isOpen,
  };
}

/**
 *  Return combo edit modal is open
 *
 */
export function useComboEditConfirmation() {
  const { isOpen } = useComboEditConfirmationSelector();

  return {
    isOpen,
  };
}
